import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { showSuccess, showError } from '../../utils/snackbar';
import './PaywallModal.css';

// After payment: show codes; download only on explicit click (progress stays in-modal)
class PaymentSuccessModal extends Component {
  // Copy text to clipboard and confirm via snackbar
  handleCopy = async (value, label) => {
    const text = value || '';
    if (!text) {
      showError('Nothing to copy');
      return;
    }
    try {
      await navigator.clipboard.writeText(text);
      showSuccess(`${label || 'Code'} copied successfully`);
    } catch (e) {
      showError('Unable to copy. Please select and copy manually.');
    }
  };

  // Close success modal when opening legal pages (blocked while preparing video)
  handleLegalNavigate = (event) => {
    if (this.props.downloading) {
      event.preventDefault();
      return;
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const {
      isOpen,
      orderId,
      guestAccessCode,
      onDownload,
      onClose,
      downloading,
      downloadProgress,
      error,
    } = this.props;

    if (!isOpen) {
      return null;
    }

    const progress = Math.max(0, Math.min(100, Number(downloadProgress) || 0));
    const ctaLabel = downloading
      ? progress > 0
        ? `Preparing your video… ${progress}%`
        : 'Unlocking download…'
      : 'Download video now';

    return (
      <div className="paywall-success-overlay" role="presentation">
        <div
          className="paywall-success-card"
          role="dialog"
          aria-modal="true"
          aria-labelledby="pay-success-title"
        >
          <button
            type="button"
            className="paywall-close"
            onClick={onClose}
            disabled={downloading}
            aria-label="Close"
          >
            ×
          </button>
          <h2 id="pay-success-title" className="paywall-title">
            Payment successful
          </h2>
          <p className="paywall-text">
            Save these codes. You need them to recover your download on another device.
          </p>
          <label className="paywall-text" htmlFor="pay-order-id">
            Order ID
          </label>
          <div className="paywall-code-row">
            <input id="pay-order-id" readOnly value={orderId || ''} />
            <button
              type="button"
              className="paywall-copy"
              onClick={() => this.handleCopy(orderId, 'Order ID')}
            >
              Copy
            </button>
          </div>
          <label className="paywall-text" htmlFor="pay-access-code">
            Guest Access Code
          </label>
          <div className="paywall-code-row">
            <input id="pay-access-code" readOnly value={guestAccessCode || ''} />
            <button
              type="button"
              className="paywall-copy"
              onClick={() => this.handleCopy(guestAccessCode, 'Guest Access Code')}
            >
              Copy
            </button>
          </div>
          <div className="paywall-warning">
            Screenshot or save these codes now. We do not auto-download after payment.
          </div>
          {/* {error ? <p className="paywall-error">{error}</p> : null} */}
          <button
            type="button"
            className="paywall-cta"
            onClick={onDownload}
            disabled={downloading}
          >
            {ctaLabel}
          </button>
          {downloading ? (
            <div
              className="paywall-progress"
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={progress}
              aria-label="Video preparation progress"
            >
              <div
                className="paywall-progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
          ) : null}
          <p className={`paywall-legal${downloading ? ' paywall-legal-disabled' : ''}`}>
            <Link to="/terms" onClick={this.handleLegalNavigate}>
              Terms
            </Link>
            {' · '}
            <Link to="/privacy-policy" onClick={this.handleLegalNavigate}>
              Privacy
            </Link>
            {' · '}
            <Link to="/refund-policy" onClick={this.handleLegalNavigate}>
              Refund
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default PaymentSuccessModal;
